import { CallStats, StatsCommon } from '#common/stats';
export class MetaStoreStats extends StatsCommon {
    fetchData;
    applyData;
    invokeProcedure;
    constructor(log) {
        super();
        this.fetchData = new CallStats('fetchData', log);
        this.applyData = new CallStats('applyData', log);
        this.invokeProcedure = new CallStats('invokeProcedure', log);
    }
}
